export const CloseIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none">
      <path d="M7.78177 16.232L16.2516 7.76217M16.2516 16.232L7.78177 7.76217" stroke="#F5222D" strokeWidth="2" />
    </svg>
  )
}
